/* eslint-disable no-underscore-dangle */
import { Component, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';

import { CarritoService } from '../../services/carrito.service';
import { UsuarioService } from '../../services/usuario.service';

@Component({
  selector: 'app-ordenes',
  templateUrl: './ordenes.page.html',
  styleUrls: ['./ordenes.page.scss'],
})
export class OrdenesPage implements ViewWillEnter {

  constructor(public _cs: CarritoService,
              public _us: UsuarioService) { }



ionViewWillEnter() {
    this._cs.cargar_ordenes();
  }


}
